import "./HighlightText.css";

export default function HighlightText({
  text,
  size = "1rem",
  padding = "0",
  fontWeight = "400",
  alignItems = "center",
  icon = null,
  iconColor = "var(--color-orange)",
  iconSize = "1.2rem"
}) {
  const sizesArray = Array.isArray(size) ? size.slice(0, 3) : [size];
  const paddingArray = Array.isArray(padding) ? padding.slice(0, 3) : [padding];

  const containerStyle = {
    alignItems,
    // Font sizes
    ...(sizesArray[0] && { "--size-0": sizesArray[0] }),
    ...(sizesArray[1] && { "--size-1": sizesArray[1] }),
    ...(sizesArray[2] && { "--size-2": sizesArray[2] }),
    // Padding values
    ...(paddingArray[0] && { "--pad-0": paddingArray[0] }),
    ...(paddingArray[1] && { "--pad-1": paddingArray[1] }),
    ...(paddingArray[2] && { "--pad-2": paddingArray[2] })
  };

  return (
    <div
      className="highlight-text"
      style={containerStyle}
      data-sizes={sizesArray.length}
      data-pads={paddingArray.length}
    >
      {icon ? (
        <i className={icon} style={{ color: iconColor, fontSize: iconSize }} />
      ) : (
        <div className="highlight-text__square" />
      )}
      <span className="highlight-text__text" style={{ fontWeight }}>
        {text}
      </span>
    </div>
  );
}
